var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center content-center justify-center p-5"},[_c('div',{staticClass:"w-full max-w-3xl"},[_c('ExternalBlocked')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }